import type { SVGProps } from 'react';
import * as React from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 5v14m-7-7h14" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgPlus;
